import React from 'react';
import { CopyCard, CopyField, setStoreCopy } from './adminSiteCopyFields';

export default function AdminSiteExtraSeoFields({ form, setField }) {
  const store = form.store_copy || {};
  const setStore = (patch) => setStoreCopy(form, setField, patch);

  return (
    <CopyCard title="Extra page SEO" subtitle="Search, account, blog, product pages — titles auto-append brand name if missing">
      <CopyField
        id="seo-search-title"
        label="Search page title"
        value={store.seo_search_title || ''}
        onChange={(v) => setStore({ seo_search_title: v })}
      />
      <CopyField
        id="seo-search-desc"
        label="Search meta description"
        value={store.seo_search_description || ''}
        onChange={(v) => setStore({ seo_search_description: v })}
        multiline={2}
      />
      <CopyField
        id="seo-track-title"
        label="Track order page title"
        value={store.seo_track_order_title || ''}
        onChange={(v) => setStore({ seo_track_order_title: v })}
      />
      <CopyField
        id="seo-track-desc"
        label="Track order meta description"
        value={store.seo_track_order_description || ''}
        onChange={(v) => setStore({ seo_track_order_description: v })}
        multiline={2}
      />
      <CopyField
        id="seo-account-title"
        label="Account page title"
        value={store.seo_account_title || ''}
        onChange={(v) => setStore({ seo_account_title: v })}
      />
      <CopyField
        id="seo-account-desc"
        label="Account meta description"
        value={store.seo_account_description || ''}
        onChange={(v) => setStore({ seo_account_description: v })}
        multiline={2}
      />
      <CopyField
        id="seo-blog-title"
        label="Blog index title"
        value={store.seo_blog_title || ''}
        onChange={(v) => setStore({ seo_blog_title: v })}
      />
      <CopyField
        id="seo-blog-desc"
        label="Blog index meta description"
        value={store.seo_blog_description || ''}
        onChange={(v) => setStore({ seo_blog_description: v })}
        multiline={2}
      />
      <CopyField
        id="seo-pdp-title-tpl"
        label="Product page title template"
        value={store.seo_pdp_title_template || ''}
        onChange={(v) => setStore({ seo_pdp_title_template: v })}
        hint="Placeholders: {title} {category} {brand}"
      />
      <CopyField
        id="seo-pdp-desc-tpl"
        label="Product meta description template"
        value={store.seo_pdp_description_template || ''}
        onChange={(v) => setStore({ seo_pdp_description_template: v })}
        multiline={2}
        hint="Placeholders: {title} {category} {brand} {description}"
      />
    </CopyCard>
  );
}
